import React, { useEffect, useState, Fragment } from 'react'
import {
    Typography,
    Paper,
    IconButton,
    FormControl,
    FormHelperText
} from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import PublishIcon from '@material-ui/icons/Publish'
import BackupIcon from '@material-ui/icons/Backup'
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore'
import firebase from '../firebase'
import { withRouter } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { ReactComponent as LoadingClock } from './clock.svg'
import * as Moment from 'moment'
import 'moment/locale/de'
import 'moment/locale/it'
import './styles.css'

const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block',
        margin: theme.spacing(1),
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top center',
        [theme.breakpoints.up(480 + theme.spacing(3) * 2)]: {
            backgroundPosition: 'center center',
        },
    },
    paper: {
        marginTop: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(2)}px`,
        [theme.breakpoints.up(620 + theme.spacing(3) * 2)]: {
            width: 600,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    submit: {
        padding: 12,
    },
    input: {
        fontSize: 92,
    },
    formHelper: {
        textAlign: 'center',
        marginTop: -5,
    },
})

function Upload(props) {
    const { classes } = props
    const [isadmin, setIsadmin] = useState(false)
    const { t, i18n } = useTranslation()
    const [logged, setLogged] = useState(false)
    const [isactive, setIsactive] = useState(false)
    const [isrestore, setIsrestore] = useState(false)
    const [backupdate, setBackupdate] = useState('')

    Moment.locale(i18n.language)

    useEffect(() => {
        document.title = window.localStorage.getItem('apptitle') + ` - ${t('dashboard.label')}`
    }, [t])

    useEffect(() => {
        if (firebase.getCurrentUsername()) {
            setLogged(true)
            return
        } else {
            alert(t('loginfirst.label'))
            window.location.href = '/'
            return null
        }
    }, [t])

    useEffect(() => {
        if (firebase.getCurrentUsername()) {
            firebase.checkClaims().then((idTokenResult) => {
                if (!!idTokenResult.claims.admin) {
                    setIsadmin(true)
                } else {
                    return
                }
            })
        }
    }, [])

    useEffect(() => {
        const unsubscribe = firebase.db.collection('backupinprogress').doc('25')
            .onSnapshot((snapshot) => {
                if (snapshot.exists) {
                    setIsactive(true)
                } else {
                    setIsactive(false)
                }
            })
        return () => unsubscribe()
    }, [])

    useEffect(() => {
        const unsubscribe = firebase.db.collection('backupdate').doc('backup')
            .onSnapshot((snapshot) => {
                if (snapshot.exists) {
                    setBackupdate(snapshot.data().createdAt)
                }
            })
        return () => unsubscribe()
    }, [])

    useEffect(() => {
        const unsubscribe = firebase.db.collection('restoreinprogress').doc('25')
            .onSnapshot((snapshot) => {
                if (snapshot.exists) {
                    setIsrestore(true)
                } else {
                    setIsrestore(false)
                }
            })
        return () => unsubscribe()
    }, [])

    return (
        <main className={classes.main}>
            <div className={classes.content}>
                {logged ?
                    <span>
                        <Paper className={classes.paper}>
                            {isadmin ?
                                <span>
                                    <Typography variant="body1" gutterBottom>
                                        <strong>{t('restorelocal.label')}</strong>
                                    </Typography>
                                    <span style={{ textAlign: 'center', }}>
                                        {isactive ?
                                            <span>
                                                <IconButton disabled color="primary" component="span">
                                                    <img src='./backup.png' className='blink-image' style={{ position: 'absolute', width: 92 }} alt='Backup in progress' />
                                                    <BackupIcon color='secondary' className={classes.input} />
                                                </IconButton>
                                                <FormHelperText className={classes.formHelper}>{t('restoreinprogress.label')}</FormHelperText>
                                                <br />
                                                <LoadingClock style={{ width: 50 }} />
                                            </span>
                                            : isrestore ?
                                                <span>
                                                    <IconButton disabled color="primary" component="span">
                                                        <img src='./restore.png' className='blink-image' style={{ position: 'absolute', width: 92 }} alt='Restore in progress' />
                                                        <SettingsBackupRestoreIcon color='secondary' className={classes.input} />
                                                    </IconButton>
                                                    <FormHelperText className={classes.formHelper}>{t('restoreinprogress.label')}</FormHelperText>
                                                    <br />
                                                    <LoadingClock style={{ width: 50 }} />
                                                </span>
                                                :
                                                <span>
                                                    <FormControl style={{
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>
                                                        <Fragment>
                                                            <input
                                                                accept="application/JSON"
                                                                className={classes.input}
                                                                id="icon-button-photo"
                                                                onChange={backupUpload}
                                                                type="file"
                                                                style={{ display: "none" }}
                                                            />
                                                            <label htmlFor="icon-button-photo">
                                                                <IconButton color="secondary" component="span">
                                                                    <PublishIcon color='secondary' className={classes.input} />
                                                                </IconButton>
                                                            </label>
                                                        </Fragment>
                                                        <FormHelperText className={classes.formHelper}>{t('uploadjson.label')}</FormHelperText>
                                                    </FormControl>
                                                </span>
                                        }
                                    </span>
                                </span>
                                :
                                <span></span>
                            }
                        </Paper>
                    </span>
                    :
                    <span></span>
                }
            </div>
        </main>
    )

    async function backupUpload(event) {
        const backupFile = event.target.files[0]
        const restoreDate = Date.now()
        try {
            if (!backupFile) {
                return
            } else {
                console.log()
                var backupName = backupFile.name
                var regex = /\.json$/
                var match = backupName.match(regex)
                if (match) {
                    await setIsrestore(true)
                    await firebase.storage.ref(`backuplocal/${backupFile.name}`).put(backupFile)
                        .then(() => {
                            firebase.storage.ref('backuplocal').child(backupFile.name).getDownloadURL()
                                .then(url => {
                                    firebase.restoreHistory(url, restoreDate, backupdate)
                                }).catch(() => {
                                    toast.error(`${t('error.label')}`)
                                })
                        }).then(() => {
                            toast.success(`${t('firestoreisrestored.label')}`)
                        })
                } else {
                    toast.error(`${t('wrongfiletype.label')}`, { autoClose: false, })
                }
            }
        } catch (error) {
            return
        }
    }

}

export default withRouter(withStyles(styles)(Upload))